{
  "labels": {
    "textSingleLine": "ข้อความ - บรรทัดเดียว",
    "textMultipleLines": "ข้อความ - หลายบรรทัด",
    "date": "วันที่",
    "trueFalse": "จริง/เท็จ",
    "singleDocument": "เอกสารเดียว",
    "multiDocument": "หลายเอกสาร",
    "number": "ตัวเลข",
    "eMail": "อีเมล",
    "phone": "โทรศัพท์",
    "dropDownSingleSelectList": "รายการแบบเลื่อนลงเลือกได้รายการเดียว",
    "dropDownMultiSelectList": "รายการแบบเลื่อนลงเลือกได้หลายรายการ",
    "comboBox": "คอมโบบ็อกซ์",
    "timestamp": "การประทับเวลา",
    "featureLink": "ลิงก์ฟีเจอร์"
  },
  "descriptions": {
    "openTextFieldSingleLine": "ช่องข้อความอิสระ บรรทัดเดียว",
    "openTextFieldMultipleLines": "ช่องข้อความอิสระ หลายบรรทัด",
    "formatMmDdYyyy": "รูปแบบ ดด/วว/ปปปป",
    "toggleButton": "ปุ่มสลับ",
    "singleFileUploadField": "ช่องอัปโหลดไฟล์เดียว",
    "multipleFileUploadField": "ช่องอัปโหลดหลายไฟล์",
    "numericInputField": " ช่องกรอกตัวเลข",
    "emailAddressInputField": "ช่องกรอกที่อยู่อีเมล",
    "format1XxxXxxXxxx": "รูปแบบ +1(XXX) XXX-XXXX",
    "selectOneOptionFromAList": "เลือกหนึ่งตัวเลือกจากรายการ",
    "selectMultipleOptionsFromAList": "เลือกหลายตัวเลือกจากรายการ",
    "singleOptionDropDownListOpenTextField": "รายการแบบเลื่อนลงเลือกได้รายการเดียว + ช่องข้อความอิสระ",
    "dateAndTimeFields": "ช่องวันที่และเวลา",
    "linkToTheFormFeatures": "ลิงก์ไปยังฟีเจอร์ของแบบฟอร์ม"
  }
}
